import {useState, useRef, useContext} from "react";
import Form from "react-bootstrap/Form";
import AppConfigContext from "../context/AppConfigContext";

const RadioField = (props) => {
    const { name, value, type, option, onRadioChange, onTextChange } = props;
    const [radioValue, setRadioValue] = useState(value);
    const radioRef = useRef();
    let radioEl = radioRef.current;

    const { config } = useContext(AppConfigContext);

    const handleTextBoxChange = (e) => {
        const customValue = e.target.value;
        if (radioEl.checked && customValue.trim() !== '') {
            setRadioValue(customValue);
            onTextChange(name, customValue);
        } else {
            setRadioValue('');
            onTextChange(name, '');
        }
    }

    return (
        <Form.Check id={`${name}-${option.id}`} {...props}>
            <Form.Check.Input ref={radioRef} type={type} name={name} onChange={onRadioChange} value={radioValue}/>
            <Form.Check.Label className="w-100">
                <Form.Control
                    type="text"
                    name={name}
                    placeholder={config.isMultiLingual ? option.label : "Other"}
                    className="border-0"
                    disabled={radioEl && !radioEl.checked}
                    onChange={handleTextBoxChange}/>
            </Form.Check.Label>
        </Form.Check>
    )
}

export default RadioField;
